import { useState, useCallback } from "react";
import { useRouter } from "next/router";

import styles from "@styles/checkout/notlogin.module.scss";
import { useApp } from "@context/AppProvider";
import { api } from "@utils/api";
import MessageComponent from "@components/common/MessageComponent";

const CheckNotLogin = ({ isBag, auctionId = null, varianceId = null }) => {
  const {
    idb: { session },
    showModel,
  } = useApp();
  const [auctLmt, setAuctLmt] = useState({
    disable: false,
    message: "",
    showEmail: false,
    email: "",
    errEmail: "",
  });
  const router = useRouter();

  const chkValidateAuction = async () => {
    const rst = await api(
      {
        url: `/auction/entry/${auctionId}/${varianceId}`,
        method: "GET",
      },
      session
    );
    if (!rst.status && rst.message) {
      setAuctLmt((preVal) => ({
        ...preVal,
        disable: true,
        message: rst.message,
      }));
    } else {
      router.push(`/guest/${auctionId}/${varianceId}`);
    }
  };

  const continueAsGuest = useCallback(async () => {
    try {
      const checkSession = JSON.parse(sessionStorage.getItem("guestCheckout"));
      const isAvailable = checkSession && Object.keys(checkSession).length > 0;

      if (!isAvailable) {
        return router.push(`/guest/checkout/info`);
      }
      router.push(`/guest/checkout`);
    } catch (e) {
      setAuctLmt((preVal) => ({
        ...preVal,
        errEmail: "Something went wrong! Please retry.",
      }));
    }
  }, [router]);

  return (
    <div className="col-md-12 col-lg-12">
      <div className={styles.checkoutLogged}>
        <h1>Hey there!</h1>
        <p className={styles.grey}>
          Please login{" "}
          {isBag ? "to shop on" : "or enter as guest to participate"}.
        </p>
        <button
          className={`${styles.btnCustom} mossBtn`}
          onClick={() => showModel("login")}
        >
          Login
        </button>
        {!isBag ? (
          <>
            <button
              onClick={chkValidateAuction}
              disabled={auctLmt.disable}
              className={`${styles.btnCustom} peachBtn`}
            >
              Enter as a guest
            </button>
            {!!auctLmt.disable && (
              <MessageComponent
                message={auctLmt.message}
                messageKey={"error"}
              />
            )}
          </>
        ) : (
          <>
            <button
              onClick={continueAsGuest}
              disabled={auctLmt.disable}
              className={`${styles.btnCustom} ${styles.lightorangebtn}`}
            >
              Continue as a guest
            </button>
          </>
        )}
        <p className="links">
          {`Would you like to open an account?`} |{" "}
          <span className="link_moss" onClick={() => showModel("register")}>
            Register here
          </span>
        </p>
      </div>
    </div>
  );
};

export default CheckNotLogin;
